/* Chalkline: loads the verified reviews section (assets/chalkline-reviews.js) from the same folder. */
(function () {
  var me = document.currentScript;
  if (!me || !me.src || document.querySelector('script[data-cl-reviews]')) return;
  var s = document.createElement('script');
  s.src = me.src.replace('chalkline-pdp.js', 'chalkline-reviews.js');
  s.defer = true;
  s.setAttribute('data-cl-reviews', '');
  document.head.appendChild(s);
})();

/* Chalkline: "Item purchased" box on the photo reviews (Loved By You), showing the
   sketchbook color each reviewer bought and that color's product photo.
   Edit PURCHASES to change which color goes with which reviewer. */
(function () {
  var IMG = {
    Blue: 'https://cdn.shopify.com/s/files/1/0650/9146/9400/files/ChalklineBlueSketchbookwithWhiteInkPen.png?v=1791571514&width=120',
    Green: 'https://cdn.shopify.com/s/files/1/0650/9146/9400/files/ForestgreenChalklinesketchbook.png?v=1791571514&width=120'
  };
  var PURCHASES = { 'Alex R': 'Blue', 'Sarah T': 'Green', 'Jessica P': 'Blue' };

  function run() {
    document.querySelectorAll('[id*="customer_reviews_carousel"] .review-card').forEach(function (card) {
      if (card.querySelector('.product-purchased-container')) return;
      var color = null;
      Object.keys(PURCHASES).forEach(function (name) {
        if (card.textContent.indexOf(name) !== -1) color = PURCHASES[name];
      });
      if (!color) return;
      var text = card.querySelector('.review-text');
      if (!text) return;
      var box = document.createElement('div');
      box.className = 'product-purchased-container';
      box.innerHTML =
        '<div class="product-purchased"><div class="product-details">' +
        '<div class="review-product-image"><img src="' + IMG[color] + '" alt="The Chalkline Sketchbook in ' + color + '" width="55" height="55" loading="lazy"></div>' +
        '<div class="product-info"><p class="product-label">Item Purchased</p>' +
        '<p class="review-product-title">The Chalkline Sketchbook</p>' +
        '<p class="product-price" style="display:flex;align-items:center;gap:6px">' +
        '<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:' + (color === 'Blue' ? '#2747c9' : '#3e7655') + '"></span>' + color + ' pages · $34.99</p>' +
        '</div></div></div>';
      text.parentNode.insertBefore(box, text.nextSibling);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
})();

/* Chalkline: turns Kaching's color dropdowns into labeled page-color swatches,
   and gives a tier without a subtitle a short "what's included" line.
   Kaching's own dropdown stays in the page (hidden) so the app keeps working. */
(function () {
  var COLORS = { Blue: '#2747c9', Green: '#3e7655' };
  var SINGLE_SUBTITLE = '1 sketchbook + 1 free white pen';

  function pick(dd, value) {
    var cb = dd.querySelector('[role="combobox"]');
    if (!cb || dd.dataset.value === value) return;
    cb.click();
    setTimeout(function () {
      var lb = document.getElementById(cb.getAttribute('aria-controls'));
      var opt = lb && lb.querySelector('[role="option"][data-value="' + value + '"]');
      if (opt) opt.click();
      else cb.click();
    }, 30);
  }

  function enhance(dd) {
    var main = dd.closest('.kaching-bundles__bar-variant-main');
    if (!main || main.querySelector('.cl-row')) return;
    var holder = dd.closest('.kaching-bundles__bar-variant');
    if (holder) holder.classList.add('cl-enhanced');

    var bar = dd.closest('.kaching-bundles__bar');
    var all = bar ? Array.prototype.slice.call(bar.querySelectorAll('.kaching-bundles__swatch-dropdown[data-name="Color"]')) : [dd];
    var n = all.indexOf(dd) + 1;

    var row = document.createElement('div');
    row.className = 'cl-row';
    var label = document.createElement('span');
    label.className = 'cl-row-label';
    var num = document.createElement('span');
    num.className = 'cl-row-num';
    num.textContent = all.length > 1 ? 'Sketchbook ' + n : 'Sketchbook';
    var picked = document.createElement('span');
    picked.className = 'cl-row-picked';
    label.appendChild(num);
    label.appendChild(picked);

    var wrap = document.createElement('div');
    wrap.className = 'cl-swatches';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Page color for sketchbook ' + n);

    Object.keys(COLORS).forEach(function (name) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cl-swatch';
      b.style.backgroundColor = COLORS[name];
      b.title = name;
      b.setAttribute('aria-label', name + ' pages');
      b.dataset.value = name;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var live = main.querySelector('.kaching-bundles__swatch-dropdown[data-name="Color"]');
        if (live) pick(live, name);
      });
      wrap.appendChild(b);
    });

    row.appendChild(label);
    row.appendChild(wrap);
    main.appendChild(row);
  }

  function sync() {
    document.querySelectorAll('.kaching-bundles .cl-row').forEach(function (row) {
      var main = row.closest('.kaching-bundles__bar-variant-main');
      var dd = main && main.querySelector('.kaching-bundles__swatch-dropdown[data-name="Color"]');
      if (!dd) return;
      var v = dd.dataset.value;
      row.querySelector('.cl-row-picked').textContent = v ? v + ' pages' : '';
      row.querySelectorAll('.cl-swatch').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.value === v ? 'true' : 'false');
      });
    });
  }

  function subtitles() {
    document.querySelectorAll('.kaching-bundles .kaching-bundles__bar').forEach(function (bar) {
      var line = bar.querySelector('.kaching-bundles__bar-second-line');
      if (!line || line.querySelector('.kaching-bundles__bar-subtitle, .cl-subtitle')) return;
      var count = bar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper').length;
      if (count > 1) return;
      var s = document.createElement('div');
      s.className = 'cl-subtitle';
      s.textContent = SINGLE_SUBTITLE;
      line.appendChild(s);
    });
  }

  function run() {
    document
      .querySelectorAll('.kaching-bundles .kaching-bundles__swatch-dropdown[data-name="Color"]')
      .forEach(enhance);
    subtitles();
    sync();
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-value', 'class'] });
  run();
})();

/* Chalkline: "See it in action" video row.
   - Uses Shopify's compressed 480p versions (about 1 MB per 6 s clip) with a poster image.
   - Nothing downloads until a video is about to scroll into view.
   - Plays muted while at least half visible, pauses when scrolled away or the tab is hidden.
   - Respects "reduce motion": no autoplay, tap to play instead. */
(function () {
  var VIDEOS = [
    { src: 'https://cdn.shopify.com/videos/c/vp/5bcc3837e7a549efa1aa53063c8db75c/5bcc3837e7a549efa1aa53063c8db75c.SD-480p-1.2Mbps-96977013.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0650/9146/9400/files/preview_images/5bcc3837e7a549efa1aa53063c8db75c.thumbnail.0000000000.jpg?v=1791578116&width=360' },
    { src: 'https://cdn.shopify.com/videos/c/vp/6d89844ecaed4f42a3b0c7de8ef43ae4/6d89844ecaed4f42a3b0c7de8ef43ae4.SD-480p-0.9Mbps-96977010.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0650/9146/9400/files/preview_images/6d89844ecaed4f42a3b0c7de8ef43ae4.thumbnail.0000000000.jpg?v=1791578105&width=360' },
    { src: 'https://cdn.shopify.com/videos/c/vp/8569b15500d44f61bf1debe6713607d1/8569b15500d44f61bf1debe6713607d1.SD-480p-1.2Mbps-96977011.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0650/9146/9400/files/preview_images/8569b15500d44f61bf1debe6713607d1.thumbnail.0000000000.jpg?v=1791578116&width=360' },
    { src: 'https://cdn.shopify.com/videos/c/vp/9f190be19dd248138199b85b10a69f65/9f190be19dd248138199b85b10a69f65.SD-480p-0.9Mbps-96977012.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0650/9146/9400/files/preview_images/9f190be19dd248138199b85b10a69f65.thumbnail.0000000000.jpg?v=1791578105&width=360' }
  ];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build() {
    if (document.querySelector('.cl-action')) return;
    var anchorTitle = document.querySelector('.comparison-title');
    var anchor = anchorTitle && anchorTitle.closest('.shopify-section');
    if (!anchor) return;

    var section = document.createElement('section');
    section.className = 'cl-action';
    section.setAttribute('aria-label', 'See it in action');
    var head = document.createElement('div');
    head.className = 'cl-action__head';
    var h = document.createElement('h2');
    h.className = 'cl-action__title';
    h.textContent = 'See It In Action';
    var p = document.createElement('p');
    p.className = 'cl-action__sub';
    p.textContent = 'Real pages. Real white ink. No filters.';
    head.appendChild(h);
    head.appendChild(p);
    var row = document.createElement('div');
    row.className = 'cl-action__row';

    VIDEOS.forEach(function (v, i) {
      var card = document.createElement('div');
      card.className = 'cl-action__card';
      var vid = document.createElement('video');
      vid.className = 'cl-action__video';
      vid.muted = true;
      vid.defaultMuted = true;
      vid.loop = true;
      vid.playsInline = true;
      vid.setAttribute('muted', '');
      vid.setAttribute('playsinline', '');
      vid.setAttribute('preload', 'none');
      vid.setAttribute('poster', v.poster);
      vid.setAttribute('aria-label', 'Chalkline sketchbook video ' + (i + 1));
      vid.dataset.src = v.src;
      card.appendChild(vid);
      if (reduceMotion) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cl-action__play';
        btn.setAttribute('aria-label', 'Play video ' + (i + 1));
        btn.addEventListener('click', function () {
          load(vid);
          if (vid.paused) { vid.play(); btn.hidden = true; }
        });
        vid.addEventListener('click', function () { vid.pause(); btn.hidden = false; });
        card.appendChild(btn);
      }
      row.appendChild(card);
    });

    section.appendChild(head);
    section.appendChild(row);
    anchor.parentNode.insertBefore(section, anchor);
    watch(section);
  }

  function load(vid) {
    if (!vid.getAttribute('src') && vid.dataset.src) {
      vid.setAttribute('src', vid.dataset.src);
      vid.load();
    }
  }

  function watch(section) {
    var vids = Array.prototype.slice.call(section.querySelectorAll('video'));
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }

    var loader = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { load(e.target); loader.unobserve(e.target); }
      });
    }, { rootMargin: '300px 300px' });

    var visible = new Set();
    var player = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          visible.add(v);
          if (!reduceMotion && !document.hidden) { load(v); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        } else {
          visible.delete(v);
          v.pause();
        }
      });
    }, { threshold: [0, 0.5] });

    vids.forEach(function (v) { loader.observe(v); player.observe(v); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { vids.forEach(function (v) { v.pause(); }); }
      else if (!reduceMotion) { visible.forEach(function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  window.addEventListener('load', build);
})();
